export default () => {
    const extensions = map => {
        const descriptors = Object.getOwnPropertyDescriptors(map)
        const canRedoChange = descriptors.canRedoChange.get.bind(map)
        const canUndoChange = descriptors.canUndoChange.get.bind(map)

        return {
            get canRedoChange() {
                return (
                    this.permission.has('write') &&
                    canRedoChange()
                )
            },

            get canUndoChange() {
                return (
                    this.permission.has('write') &&
                    canUndoChange()
                )
            },
        }
    }

    return {extensions}
}
